import { PropsWithChildren, ReactElement } from "react";
import BaseProviders from "../../components/providers/BaseProviders";
import CrmConnectionProviderWrapper from "../../components/providers/CrmConnectionProviderWrapper";

/**
 * Providers for the CRM app.
 */
export default function Providers({ children }: PropsWithChildren): ReactElement {
  return (
    <BaseProviders>
      <CrmConnectionProviderWrapper>
        {children}
      </CrmConnectionProviderWrapper>
    </BaseProviders>
  );
}
